import React from 'react';
import { Table } from 'antd';
const columns = [
  {
    title: 'Site Name',
    dataIndex: 'position',
    width: "180%",
  },
  {
    title: 'Total Downloads',
    dataIndex: 'downloads',
    width: "100%",
  },
];
const MapChart = (props) => (
  <Table
    className='wday-table'
    columns={columns}
    dataSource={props.downlodsBySite}
    pagination={false}
    size="small"
    scroll={{
      y: 220,
    }}
  />
);
export default MapChart;




